import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import { AuthPromptProvider } from "./prompt";
import { ImageViewerProvider } from "./lightbox";
import { MusicPlayerProvider, PlayerBar } from "./player";
import { AdsProvider, AdBanner } from "./ads";
import Sidebar, { MobileNav } from "./components/Sidebar";
import TopBar from "./components/TopBar";
import Logo from "@/components/landing/Logo";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Watch from "./pages/Watch";
import Shorts from "./pages/Shorts";
import { SeriesList, SeriesDetail } from "./pages/Series";
import Music from "./pages/Music";
import { LiveList, LiveDetail } from "./pages/Live";
import Messages from "./pages/Messages";
import JoinGroup from "./pages/JoinGroup";
import { CreatorProfile, MyProfile } from "./pages/Profile";
import Upload from "./pages/Upload";
import Notifications from "./pages/Notifications";
import Search from "./pages/Search";
import { Dashboard, Blocked, Security } from "./pages/Account";
import AdminPanel from "./pages/Admin";
import GoLive from "./pages/GoLive";
import PastLive from "./pages/PastLive";
import Wallet from "./pages/Wallet";

const Gate = () => {
  const { ready } = useAuth();
  if (!ready) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-obsidian" data-testid="web-loading">
        <Logo size={64} />
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/10 border-t-crimson" />
      </div>
    );
  }
  return <Shell />;
};

const Shell = () => {
  const { pathname } = useLocation();
  const noBanner = pathname === "/app" || pathname.startsWith("/app/messages");

  return (
    <div className="min-h-screen bg-obsidian font-body text-slate-100" data-testid="web-app-shell">
      <Sidebar />
      <div className="lg:pl-20">
        <TopBar />
        <main className="px-4 pb-24 pt-20 sm:px-6 lg:px-8 lg:pb-10">
          {!noBanner && <AdBanner />}
          <Routes>
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="watch/:id" element={<Watch />} />
            <Route path="shorts" element={<Shorts />} />
            <Route path="series" element={<SeriesList />} />
            <Route path="series/:id" element={<SeriesDetail />} />
            <Route path="music" element={<Music />} />
            <Route path="live" element={<LiveList />} />
            <Route path="live/:id" element={<LiveDetail />} />
            <Route path="messages" element={<Messages />} />
            <Route path="messages/:cid" element={<Messages />} />
            <Route path="join/:code" element={<JoinGroup />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="upload" element={<Upload />} />
            <Route path="profile" element={<MyProfile />} />
            <Route path="creator/:id" element={<CreatorProfile />} />
            <Route path="search" element={<Search />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="wallet" element={<Wallet />} />
            <Route path="blocked" element={<Blocked />} />
            <Route path="security" element={<Security />} />
            <Route path="admin" element={<AdminPanel />} />
            <Route path="go-live" element={<GoLive />} />
            <Route path="past-live" element={<PastLive />} />
          </Routes>
        </main>
      </div>
      <PlayerBar />
      <MobileNav />
    </div>
  );
};

const WebApp = () => (
  <AuthPromptProvider>
    <AuthProvider>
      <AdsProvider>
        <ImageViewerProvider>
          <MusicPlayerProvider>
            <Gate />
          </MusicPlayerProvider>
        </ImageViewerProvider>
      </AdsProvider>
    </AuthProvider>
  </AuthPromptProvider>
);

export default WebApp;
